module.exports = __webpack_public_path__ + "img/m-screen-logo.7ce2913d.png";